// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700;800;900&family=Playfair+Display:ital@0;1&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: auto;
  background: transparent;
  font-family: 'Poppins', sans-serif;
  padding: 0;
  width: 100%;
}

.login-box {
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  width: 100%;
  max-width: 100%;
  animation: none;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.login-title {
  font-family: 'Orbitron', sans-serif;
  font-size: 28px;
  font-weight: 800;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 2px;
  margin: 0 0 10px 0;
  text-transform: uppercase;
  font-style: italic;
}

.login-subtitle {
  color: #666;
  font-size: 14px;
  margin: 0;
  letter-spacing: 0.5px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-weight: 600;
  color: #333;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-input {
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
  transition: all 0.3s ease;
  background: #f9f9f9;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input:disabled {
  background: #f0f0f0;
  cursor: not-allowed;
  opacity: 0.6;
}

.error-message {
  background: #fee;
  color: #c33;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 13px;
  border-left: 4px solid #c33;
  animation: shake 0.3s ease-in-out;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

.login-button {
  padding: 14px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 10px;
}

.login-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);
}

.login-button:active:not(:disabled) {
  transform: translateY(0);
}

.login-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.login-footer {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.footer-text {
  color: #666;
  font-size: 12px;
  margin: 0;
  letter-spacing: 0.5px;
}

.toggle-form-btn {
  background: none;
  border: none;
  color: #667eea;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  font-size: 12px;
  padding: 0;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.toggle-form-btn:hover:not(:disabled) {
  color: #764ba2;
  text-decoration: underline;
}

.toggle-form-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .login-box {
    padding: 40px 30px;
  }

  .login-title {
    font-size: 24px;
    letter-spacing: 1.5px;
  }

  .login-button {
    padding: 12px 16px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .login-container {
    padding: 10px;
  }

  .login-box {
    padding: 30px 20px;
    border-radius: 15px;
  }

  .login-title {
    font-size: 20px;
    letter-spacing: 1px;
  }

  .login-subtitle {
    font-size: 12px;
  }

  .form-input {
    padding: 10px 12px;
    font-size: 13px;
  }

  .login-button {
    padding: 11px 14px;
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700;800;900&family=Playfair+Display:ital@0;1&display=swap');\n\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: auto;\n  background: transparent;\n  font-family: 'Poppins', sans-serif;\n  padding: 0;\n  width: 100%;\n}\n\n.login-box {\n  background: transparent;\n  border-radius: 0;\n  box-shadow: none;\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n  animation: none;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.login-title {\n  font-family: 'Orbitron', sans-serif;\n  font-size: 28px;\n  font-weight: 800;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: 2px;\n  margin: 0 0 10px 0;\n  text-transform: uppercase;\n  font-style: italic;\n}\n\n.login-subtitle {\n  color: #666;\n  font-size: 14px;\n  margin: 0;\n  letter-spacing: 0.5px;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-label {\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.form-input {\n  padding: 12px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: 'Poppins', sans-serif;\n  transition: all 0.3s ease;\n  background: #f9f9f9;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #667eea;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-input:disabled {\n  background: #f0f0f0;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.error-message {\n  background: #fee;\n  color: #c33;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  border-left: 4px solid #c33;\n  animation: shake 0.3s ease-in-out;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-5px); }\n  75% { transform: translateX(5px); }\n}\n\n.login-button {\n  padding: 14px 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-top: 10px;\n}\n\n.login-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);\n}\n\n.login-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.login-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.login-footer {\n  text-align: center;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.footer-text {\n  color: #666;\n  font-size: 12px;\n  margin: 0;\n  letter-spacing: 0.5px;\n}\n\n.toggle-form-btn {\n  background: none;\n  border: none;\n  color: #667eea;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n  font-size: 12px;\n  padding: 0;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.toggle-form-btn:hover:not(:disabled) {\n  color: #764ba2;\n  text-decoration: underline;\n}\n\n.toggle-form-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .login-box {\n    padding: 40px 30px;\n  }\n\n  .login-title {\n    font-size: 24px;\n    letter-spacing: 1.5px;\n  }\n\n  .login-button {\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-container {\n    padding: 10px;\n  }\n\n  .login-box {\n    padding: 30px 20px;\n    border-radius: 15px;\n  }\n\n  .login-title {\n    font-size: 20px;\n    letter-spacing: 1px;\n  }\n\n  .login-subtitle {\n    font-size: 12px;\n  }\n\n  .form-input {\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n\n  .login-button {\n    padding: 11px 14px;\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
